import type { QueryClient } from "@tanstack/react-query";
import type { UseGamesResult } from "@/app/(api)/api/listGames/useGames.js";
import { invalidateGames, useGames } from "@/app/(api)/api/listGames/useGames.js";
import { invalidateInfiniteGames } from "@/app/(api)/api/listGames/useInfiniteGames.js";
import type { APIUser } from "@rosette/ts/src/business/api/api_schema.js";


const RECENT_GAMES_LIMIT = 3;


export function useRecentGames(user: APIUser): UseGamesResult {
    return useGames(user, null, RECENT_GAMES_LIMIT);
}


export function invalidateRecentGames(queryClient: QueryClient) {
    invalidateGames(queryClient, null, RECENT_GAMES_LIMIT);
    invalidateInfiniteGames(queryClient);
}
